export default "__VITE_ASSET__B9rq6ZDZ__"